import { useDataValue } from 'Simple/Data.js'

/** @type {import('Simple/types.js').useDataConfiguration} */
export default function useDataConfiguration(props, data) {
  let location_id = useDataValue({
    context: 'automation',
    path: 'location_id',
    viewPath: props.viewPath,
  })

  return {
    variables: {
      location_id,
    },
    requestPolicy: 'cache-and-network',
  }
}
